import request from "@/utils/request";

const { ElMessage } = require("element-plus");

export default {
  name: "selfInfo",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) return callback(new Error("请输入手机号"));
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    const validateConfirmPwd = (rule, value, callback) => {
      if (!value) return callback(new Error("请再次输入新密码"));
      if (value !== this.pwdData.newPassword) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    return {
      isMobile: window.innerWidth <= 768,
      dialogVisible: false,
      pwdDialogVisible: false,
      identity: "",
      form: {},
      editData: {},
      editErrors: {},
      pwdErrors: {},
      editRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        phone_num: [{ required: true, validator: validatePhone, trigger: "blur" }],
        email: [{ type: "email", message: "请输入正确的邮箱地址", trigger: "blur" }],
      },
      pwdData: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      pwdRules: {
        oldPassword: [{ required: true, message: "请输入当前密码", trigger: "blur" }],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, max: 32, message: "密码长度6-32位", trigger: "blur" },
        ],
        confirmPassword: [{ required: true, validator: validateConfirmPwd, trigger: "blur" }],
      },
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    this.loadInfo();
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    loadInfo() {
      const userStr = sessionStorage.getItem("user");
      if (!userStr) return;
      this.form = JSON.parse(userStr);
      this.identity = sessionStorage.getItem("identity");
      if (this.form.username && (!this.form.dormRoom || !this.form.dormRoom.dormBuildId)) {
        this.refreshDormRoom(this.form.username);
      }
    },
    async refreshDormRoom(username) {
      try {
        const res = await request.get("/room/getMyRoom/" + username);
        if (res.code === "0" && res.data) {
          this.form.dormRoom = {
            dormBuildId: res.data.dormBuildId,
            dormRoomId: res.data.dormRoomId,
          };
          const userStr = sessionStorage.getItem("user");
          if (userStr) {
            const userData = JSON.parse(userStr);
            userData.dormRoom = this.form.dormRoom;
            sessionStorage.setItem("user", JSON.stringify(userData));
          }
        }
      } catch (e) {
        console.error("refreshDormRoom error", e);
      }
    },
    edit() {
      this.editData = { ...this.form };
      this.editErrors = {};
      this.dialogVisible = true;
    },
    cancel() {
      this.dialogVisible = false;
      this.editErrors = {};
    },

    // 移动端手动校验
    validateEditMobile() {
      this.editErrors = {};
      let valid = true;
      if (!this.editData.name || !this.editData.name.trim()) {
        this.editErrors.name = "请输入姓名";
        valid = false;
      }
      if (!this.editData.gender) {
        this.editErrors.gender = "请选择性别";
        valid = false;
      }
      if (!this.editData.phone_num) {
        this.editErrors.phone_num = "请输入手机号";
        valid = false;
      } else if (!/^1[3-9]\d{9}$/.test(this.editData.phone_num)) {
        this.editErrors.phone_num = "手机号格式不正确";
        valid = false;
      }
      if (this.editData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.editData.email)) {
        this.editErrors.email = "请输入正确的邮箱地址";
        valid = false;
      }
      return valid;
    },

    async save() {
      // 移动端用手动校验，PC端用 el-form 校验
      if (this.isMobile) {
        if (!this.validateEditMobile()) return;
      } else {
        try {
          await this.$refs.editForm.validate();
        } catch {
          return;
        }
      }
      try {
        const res = await request.put("/" + this.identity + "/update", this.editData);
        if (res.code === "0") {
          ElMessage({ message: "修改成功", type: "success" });
          const updatedUser = { ...this.editData, ...res.data };
          sessionStorage.setItem("user", JSON.stringify(updatedUser));
          this.form = { ...updatedUser };
          this.dialogVisible = false;
        } else {
          ElMessage({ message: res.msg, type: "error" });
        }
      } catch (e) {
        ElMessage({ message: "修改失败", type: "error" });
      }
    },
    showChangePassword() {
      this.pwdData = { oldPassword: "", newPassword: "", confirmPassword: "" };
      this.pwdErrors = {};
      this.pwdDialogVisible = true;
    },
    cancelPwd() {
      this.pwdDialogVisible = false;
      this.pwdErrors = {};
    },

    // 移动端密码手动校验
    validatePwdMobile() {
      this.pwdErrors = {};
      let valid = true;
      if (!this.pwdData.oldPassword) {
        this.pwdErrors.oldPassword = "请输入当前密码";
        valid = false;
      }
      if (!this.pwdData.newPassword) {
        this.pwdErrors.newPassword = "请输入新密码";
        valid = false;
      } else if (this.pwdData.newPassword.length < 6 || this.pwdData.newPassword.length > 32) {
        this.pwdErrors.newPassword = "密码长度6-32位";
        valid = false;
      }
      if (!this.pwdData.confirmPassword) {
        this.pwdErrors.confirmPassword = "请再次输入新密码";
        valid = false;
      } else if (this.pwdData.confirmPassword !== this.pwdData.newPassword) {
        this.pwdErrors.confirmPassword = "两次输入密码不一致";
        valid = false;
      }
      return valid;
    },

    async savePwd() {
      if (this.isMobile) {
        if (!this.validatePwdMobile()) return;
      } else {
        try {
          await this.$refs.pwdForm.validate();
        } catch {
          return;
        }
      }
      if (this.pwdData.oldPassword !== this.form.password) {
        if (this.isMobile) {
          this.pwdErrors.oldPassword = "当前密码不正确";
        } else {
          ElMessage({ message: "当前密码不正确", type: "error" });
        }
        return;
      }
      try {
        const res = await request.put("/" + this.identity + "/update", {
          username: this.form.username,
          password: this.pwdData.newPassword,
        });
        if (res.code === "0") {
          ElMessage({ message: "密码修改成功", type: "success" });
          this.form.password = this.pwdData.newPassword;
          sessionStorage.setItem("user", JSON.stringify(this.form));
          this.pwdDialogVisible = false;
        } else {
          ElMessage({ message: res.msg, type: "error" });
        }
      } catch (e) {
        ElMessage({ message: "密码修改失败", type: "error" });
      }
    },
  },
};
